import React from 'react'
import "./ProductStatistics.css";


const Separator = () => (
    <img src="/images/separator.svg" alt="|" className="stat-separator" />
);

const isMobile = window.innerWidth <= 768;

export const ProductStatistics = ({ stats }) => {
    if (!isMobile) {
        return (
            <div className="statistics-container">
                <div className="statistics-row top-row">
                    {stats.slice(0, 4).map((stat, idx) => (
                        <React.Fragment key={stat.value + idx}>
                            <div className="stat-item top-stat">
                                <span className="stat-value">{stat.value}</span>
                                <span className="stat-description">{stat.description}</span>
                            </div>
                            {idx < 3 && <Separator />}
                        </React.Fragment>
                    ))}
                </div>
                <div className="statistics-row bottom-row">
                    {stats.slice(4).map((stat, idx) => (
                        <React.Fragment key={stat.value + idx}>
                            <div className="stat-item bottom-stat">
                                <span className="stat-value">{stat.value}</span>
                                <span className="stat-description">{stat.description}</span>
                            </div>
                            {idx < 2 && <Separator />}
                        </React.Fragment>
                    ))}
                </div>
            </div>
        );
    } else {
        return (
            <div className="statistics-container">
                {stats.slice(0, 6).map((item, index) => (
                    <div key={index} className="stats-card half-width">
                        <span className="stat-value">{item.value}</span>
                        <span className="stat-description">{item.description}</span>
                    </div>
                ))}
                <div className="stats-card full-width">
                    <span className="stat-value">{stats[6].value}</span>
                    <span className="stat-description">{stats[6].description}</span>
                </div>
            </div>

        );
    }
};

